import { TransitSvg } from "../icons";
import { LAYER_SETTINGS_TYPES } from "../../constants";
import type { LayerPattern } from "..";
import { state } from "../../../store/state";
import StratumsColorsWidget from "./StratumsColorsWidget";

const defaultStratumColors = ["#f542c4", "#fbbeff", "#7cffaf", "#ff9b9b", "#83caff", "#9be229", "#ff63ff", "#0deecb", "#ff840c", "#9c6fff", "#14df13", "#ff2d7b", "#00a4ff", "#878800", "#c71ef4", "#00b347", "#db2400", "#2147e9", "#0c7e00", "#ad0065", "#005d65"];

export const wellsTransit: LayerPattern = {
    id: "WellsTransit",
    key: "well_transit_v3",
    title: "Транзитный фонд",
    icon: TransitSvg,
    settings: [

    ],
    settingsInit: () => {
        const stratumColors:Record<string, string> = {};
        Object.entries(state.stratumsLegendTransit).forEach(([stratum, _title], ind) => {
            stratumColors[stratum.toString()] = defaultStratumColors[ind % defaultStratumColors.length];
        })
        return [
            {
                title: "Настройки:",
                key: "props_title",                    
                type: LAYER_SETTINGS_TYPES.TITLE,   
                defaultValue: false,     
                level: 0,
            },
            {
                title: "Простой вид",
                key: "simplified",                    
                type: LAYER_SETTINGS_TYPES.GROUP_CHECKED,   
                defaultValue: false,     
                level: 0,
            },
            {
                title: "Отображать скважины без нефтегазонасыщения",
                key: "transit_mode",                    
                type: LAYER_SETTINGS_TYPES.GROUP_CHECKED_01,
                defaultValue: 0,     
                level: 0,
            },
            {
                title: "Цвет объекта разработки",
                key: "stratums_color",                    
                type: LAYER_SETTINGS_TYPES.CUSTOM,
                defaultValue: stratumColors,
                widget: StratumsColorsWidget,     
                level: 0,
            },
        ];
    },
}